export default class IntegralRecordController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/integralRecord/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/integralRecord/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/integralRecord/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/integralRecord/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/integralRecord/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/integralRecord/delete', 'post', params, axiosOption, httpOption);
  }
  static listStatistics (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/integralRecord/listStatistics', 'post', params, axiosOption, httpOption);
  }
  static exportStatistics (sender, params, fileName) {
    return sender.download('/admin/app/integralRecord/exportStatistics', params, fileName);
  }
  static yearIntegral (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/integralRecord/yearIntegral', 'get', params, axiosOption, httpOption);
  }
}
